const ACTIVE_POST_MESSAGE_CLASS = 'form-post-message--show';

/** @type {HTMLFormElement} */
export const formElement = document.querySelector('[data-form]');

/** @type {HTMLElement} */
const successMessageElement = document.querySelector('[data-form-success]');

/** @type {HTMLElement} */
const errorMessageElement = document.querySelector('[data-form-error]');

if (formElement) {
    /** @type {HTMLElement} */
    const fileInput = formElement.querySelector('input[name="file[]"]');

    /** @type {HTMLElement} */
    const fileName = formElement.querySelector('.file-element__file-name');

    const changeFileName = () => {
        const [, , filePath] = fileInput.value.split('\\');
        fileName.innerHTML = filePath;
    };

    fileInput.addEventListener('change', changeFileName);
}

/**
 * @param {HTMLInputElement} input
 * @returns {String}
 */
const getValidationErrorType = (input) => {
    const { validity } = input;
    const isRadio = input.type === 'radio';
    const isCheckbox = input.type === 'checkbox';

    const emptyErrorType = isCheckbox || isRadio ? input.type : 'empty';

    if (validity.valueMissing) return emptyErrorType;
    if (validity.patternMismatch) return 'pattern';
    if (validity.typeMismatch) return 'format';

    return '';
};

/** @param {HTMLLabelElement} label */
const configureBoundElement = (label) => {
    const boundElementName = label.getAttribute('data-bind');
    const boundElements = document.querySelectorAll(`[data-${boundElementName}]`);

    if (boundElements.length && boundElementName === 'poll') {
        [...boundElements].forEach((boundElement) => {
            boundElement.setAttribute('data-invalid', 'radio');
        });
    }
};

/** @param {HTMLInputElement} input */
const setValidationState = (input) => {
    /** @type {HTMLLabelElement} */
    const label = input.parentElement;

    if (label.tagName !== 'LABEL') {
        throw Error('Input element should be wrapped by Label element for validation messages');
    }

    if (input.validity.valid) {
        label.removeAttribute('data-invalid');
    } else {
        label.setAttribute('data-invalid', getValidationErrorType(input));

        configureBoundElement(label);
    }
};

/** @param {Event} event */
const validateInput = (event) => {
    event.preventDefault();

    /** @type {HTMLInputElement} */
    const input = event.currentTarget;

    setValidationState(input);

    if (input.type === 'checkbox' || input.type === 'radio') {
        input.addEventListener('change', validateInput);
    } else {
        input.addEventListener('blur', validateInput);
    }
};

export const validateForm = () => {
    [...formElement.elements].forEach((input) => {
        input.addEventListener('invalid', validateInput);
    });
};

/**
 * @param {Boolean} isPassed
 */
export const showFormState = (isPassed) => {
    if (isPassed && successMessageElement) {
        successMessageElement.classList.add(ACTIVE_POST_MESSAGE_CLASS);
    } else if (errorMessageElement) {
        errorMessageElement.classList.add(ACTIVE_POST_MESSAGE_CLASS);
    }
};

export const hideFormState = () => {
    if (successMessageElement) {
        successMessageElement.classList.remove(ACTIVE_POST_MESSAGE_CLASS);
    }

    if (errorMessageElement) {
        errorMessageElement.classList.remove(ACTIVE_POST_MESSAGE_CLASS);
    }
};
